import 'keen-slider/keen-slider.min.css';
import React, { useState, useEffect, useRef } from 'react';
import { useKeenSlider } from 'keen-slider/react';
import { Link } from 'react-router-dom';
import { useNavigate } from "react-router-dom";
import { useOrders } from '../../pages/DefaultPage/connect/Orders';
import persian from "react-date-object/calendars/persian"
import persian_fa from "react-date-object/locales/persian_fa"
import { DateObject } from 'react-multi-date-picker';
import moment from 'jalali-moment';
import Slider from "react-slick";
import { baseUrlWithoutApi } from '../../baseurl';
import { useUserInfo } from '../../pages/Profile/connect/User';
import "./ADstyles.css"
import CheckImg from '../CheckImg/CheckImg';
function TwoCard({ key, item, onClick, isSearch, isInAllAds, registerStatusCode }) {
    const currentPath = window.location.pathname
    const status = { 23: "تایید شده", 24: "در انتظار تایید", 25: "رد شده", 26: "در انتظار پرداخت", null: "در انتظار تایید" }
    const [usedInProfilePage, setUsedInProfilePage] = useState(false)
    const defultImgs = { 1: "/imgs/img-n-1.svg", 2: "/imgs/img-n-2.svg", 3: "/imgs/img-n-3.svg", 4: "/imgs/img-n-4.svg" }

    // console.log("rndInt", rndInt)
    // slider
    const orderImg = useOrders((state) => state.orderImg);
    const loader = useOrders((state) => state.loader);
    const { getDetailsOrders } = useOrders((state) => state.actions);
    const isUserBlocked = useUserInfo((state) => state.isUserBlocked)
    const { getIsUserBlocked } = useUserInfo((state) => state.actions);
    const [redirectUrl, setRedirectUrl] = useState("");
    const navigate = useNavigate();
    const [currentSlide, setCurrentSlide] = useState(0)
    const [loaded, setLoaded] = useState(false)
    const [sliderRef, instanceRef] = useKeenSlider({
        initial: 1,
        slideChanged(slider) {
            setCurrentSlide(slider.track.details.rel)
        },
        created() {
            setLoaded(true)
        },
    })

    const getIsUserBlockedHandler = async () => {
        await getIsUserBlocked(localStorage.getItem("usruserCode"), localStorage.getItem("veeuToken"))
    }

    // const moveDetailPageHandler = async () => {
    //     if (onClick) {
    //         onClick()
    //         return;
    //     }
    //     localStorage.setItem("usruserCode", item.usruserCode)
    //     await getIsUserBlockedHandler()
    //     if (isUserBlocked) {
    //         navigate(`/AdvertiseDetail/${item.id}`)

    //     } else {
    //         navigate(`/AdvertiseDetail/${item.id}`)
    //     }


    // }
    const moveDetailPageHandler = async () => {
        if (onClick) {
            onClick();
            return;
        }
        localStorage.setItem("usruserCode", item.usruserCode);
        await getIsUserBlockedHandler();
    };
    const dateNew = moment.utc(new Date(), "UTC/GMT").local().format().slice(0, 16);
    const [dateStatus, setDateStatus] = useState("no date")
    const dateStatusHandler = async () => {
        if (item) {
            if (item.adsDateTime.slice(0, 13) == dateNew.slice(0, 13)) {
                setDateStatus("دقایقی پیش")
            }
            else if (item.adsDateTime.slice(0, 11) == dateNew.slice(0, 11)) {
                setDateStatus("ساعاتی پیش")
            }
            else if (item.adsDateTime.slice(8, 10) == dateNew.slice(8, 10) - 1) {
                setDateStatus("روز پیش")
            }
            // else if (item.adsDateTime.slice(0, 5) == dateNew.slice(0, 5)) {
            else {
                setDateStatus(new DateObject(item.adsDateTime.slice(0, 10)).convert(persian, persian_fa).format())
            }
        }
    }
    useEffect(() => {
        dateStatusHandler()
    }, [])


    useEffect(() => {
        if (currentPath === '/Profile' && !usedInProfilePage) {
            setUsedInProfilePage(true);
        }
    }, [currentPath, usedInProfilePage]);


    // useEffect(() => {
    function CheckImage(imageUrlToCheck) {
        const [rndInt, setRndInt] = useState(1)
        const imageUrl = `${baseUrlWithoutApi}${imageUrlToCheck}`;
        const [imageExists, setImageExists] = useState(false);
        useEffect(() => {
            if (imageUrlToCheck) {
                const img = new Image();
                img.src = imageUrl;
                img.onload = () => setImageExists(true);
                img.onerror = () => setImageExists(false);
            } else {
                setRndInt(Math.floor(Math.random() * 4) + 1)
            }
        }, [imageUrl]);
        return (
            imageUrlToCheck ? (
                <div className={`flex rounded w-full h-full border border-b border-b-2 bg-gray-200
                      bg-no-repeat TwoCard  bg-center bg-cover ${(isSearch || isInAllAds) ? "style-for-fixed-w-h-2" : "style-for-fixed-w-h"}`}
                    style={{ backgroundImage: `url(${imageExists && imageUrl})` }}></div>
            ) : (
                <div className='w-full h-full flex items-center justify-center bg-gray-200 rounded'>
                    <img className="flex border border-b border-b-2 p-[15px]  bg-no-repeat TwoCard style-for-fixed-w-h rounded" src={defultImgs[rndInt]} alt="img1" />
                </div>
            )
        );
    }
    // }, [])
    // console.log("itemmmmmmmmmm", item);

    return (
        <>
            <Link
                to={`/AdvertiseDetail/${item.id}`}  // fallback URL (won't be used due to preventDefault)
                className="single_frame"
                onClick={moveDetailPageHandler} 
                // onClick={async (e) => {
                //     e.preventDefault(); // prevent the immediate navigation
                //     await moveDetailPageHandler();
                // }}
            >
                {/* <div onClick={() => moveDetailPageHandler()} 
                className={`single_frame`}>*/}
                {usedInProfilePage && <p className='absolute -top-2 left-0 text-sm '>
                    {status[registerStatusCode]}
                </p>}

                {item && <>
                    <div className='p-1 w-full'>
                        <p className={`my-2 text-start font-bold text-[14px] text-ellipsis overflow-hidden  line-clamp-1 `}>
                            {item.adsTitle}
                        </p>
                        {
                            item.detailInMasterCode == 9 ? (
                                <div className='flex flex-col  w-full justify-between gap-2 items-center text-[14px] font-bold text-gray-500'>
                                    <div className='flex w-full justify-between'>
                                        <p>کمترین اجاره:</p>
                                        {
                                            item.minShortTermRentPrice ? (<p>{item.minShortTermRentPrice.toLocaleString('fa')} تومان</p>) : (<p>توافقی</p>)
                                        }
                                    </div>
                                </div>
                            ) :
                                item.adsMainCategoryCode == 1 ? (
                                    <div className={`grid grid-cols-1 gap-2`}>
                                        {
                                            item.br_AdsPrptyTradeTypeCode == 7 && (
                                                <div className='flex flex-col w-full justify-between gap-2 items-center text-[14px] font-bold text-gray-500 '>
                                                    <div className='flex w-full justify-between'>
                                                        <p>قیمت تا:</p>
                                                        {
                                                            item.br_BuyPriceTo ? (<p>{item.br_BuyPriceTo.toLocaleString('fa')} تومان</p>) : (<p>توافقی</p>)
                                                        }
                                                    </div>
                                                </div>
                                            )
                                        }
                                        {
                                            item.br_AdsPrptyTradeTypeCode == 8 && (
                                                <div className='flex flex-col w-full justify-between gap-2 items-center text-[14px] font-bold text-gray-500'>
                                                    <div className='flex w-full justify-between'>
                                                        <p>ودیعه تا:</p>
                                                        {
                                                            item.br_RentDeposintTo ? (<p>{item.br_RentDeposintTo.toLocaleString('fa')} تومان</p>) : (<p>توافقی</p>)
                                                        }
                                                    </div>
                                                    <div className='flex w-full justify-between'>
                                                        <p>اجاره تا:</p>
                                                        {
                                                            item.br_RentPriceTo ? (<p>{item.br_RentPriceTo.toLocaleString('fa')} تومان</p>) : (<p>توافقی</p>)
                                                        }
                                                    </div>
                                                </div>
                                            )
                                        }
                                        {
                                            !item.br_IsApplicantRentBuyProperty && (
                                                <div className='flex flex-col w-full justify-between gap-2 items-center text-[14px] font-bold '>
                                                    {item.isForRent ? (
                                                        <div className='flex w-full justify-between'>
                                                            <p className='text-gray-500'>ودیعه:</p>
                                                            {
                                                                item.deposit ? (<p>{item.deposit.toLocaleString('fa')} تومان</p>) : (<p>رایگان</p>)
                                                            }
                                                        </div>
                                                    ) : (

                                                        <div className='flex w-full justify-between'>
                                                            {item?.adsPrptyTradeTypeCode !== 4 && (
                                                                <>
                                                                    <p className='text-gray-500'>متری:</p>
                                                                    {


                                                                        item.pricePerMeter ? (<p>{item.pricePerMeter.toLocaleString('fa')} تومان</p>) : (<p>توافقی </p>)
                                                                    }
                                                                </>
                                                            )}

                                                        </div>
                                                    )}

                                                </div>
                                            )}
                                        {
                                            !item.br_IsApplicantRentBuyProperty && (
                                                <div className='flex justify-between gap-2 items-center flex-col text-[14px] font-bold '>
                                                    {item.isForRent ? (
                                                        <div className='flex w-full justify-between'>
                                                            <p className='text-gray-500'>اجاره:</p>
                                                            {
                                                                item.rentPerMonth ? (<p>{item.rentPerMonth.toLocaleString('fa')} تومان</p>) : (<p>رایگان</p>)
                                                            }
                                                        </div>
                                                    ) : (

                                                        <div className='flex w-full justify-between'>
                                                            {

                                                                item?.adsPrptyTradeTypeCode !== 4 && (
                                                                    <>
                                                                        <p className='text-gray-500'>کل:</p>
                                                                        {
                                                                            item.totalPrice ? (<p>{item.totalPrice.toLocaleString('fa')} تومان</p>) : (<p>توافقی</p>)
                                                                        }
                                                                    </>)

                                                            }

                                                        </div>
                                                    )}

                                                </div>
                                            )
                                        }
                                        {/* {
                                        !item.br_IsApplicantRentBuyProperty ? (
                                            <div className='flex flex-col w-full justify-between gap-2 items-center text-[14px] font-bold text-gray-500'>
                                                {item.isForRent ? (
                                                    <div className='flex w-full justify-between'>
                                                        <p>ودیعه:</p>
                                                        {
                                                            item.deposit ? (<p>{item.deposit.toLocaleString('fa')} تومان</p>) : (<p>رایگان</p>)
                                                        }
                                                    </div>
                                                ) : (
                                                    <div className='flex w-full justify-between'>
                                                        <p>متری:</p>
                                                        {
                                                            item.pricePerMeter ? (<p>{item.pricePerMeter.toLocaleString('fa')} تومان</p>) : (<p>توافقی</p>)
                                                        }
                                                    </div>
                                                )}

                                            </div>
                                        ):""}
                                    {
                                        !item.br_IsApplicantRentBuyProperty ? (
                                            <div className='flex justify-between gap-2 items-center flex-col text-[14px] font-bold text-gray-500'>

                                                {item.isForRent ? (
                                                    <div className='flex w-full justify-between'>
                                                        <p>اجاره:</p>
                                                        {
                                                            item.rentPerMonth ? (<p>{item.rentPerMonth.toLocaleString('fa')} تومان</p>) : (<p>رایگان</p>)
                                                        }
                                                    </div>
                                                ) : (
                                                    <div className='flex w-full justify-between'>
                                                        <p>کل:</p>
                                                        {
                                                            item.totalPrice ? (<p>{item.totalPrice.toLocaleString('fa')} تومان</p>) : (<p>توافقی</p>)
                                                        }
                                                    </div>
                                                )}

                                            </div>
                                        ):""
                                    } */}
                                    </div>
                                ) : (
                                    <div className='flex w-full items-center justify-between font-bold text-gray-500'>
                                        <p>قیمت:</p>
                                        {
                                            item.price ? (<p>{item.price.toLocaleString('fa')} تومان</p>) : (<p>توافقی</p>)
                                        }
                                    </div>
                                )
                        }
                        <div className={`flex w-full justify-between items-center text-gray-500 text-sm hidden`}>
                            <p>قیمت:</p>
                            {
                                item.price ? (<p>{item.price.toLocaleString('fa')} تومان</p>) : (<p>توافقی</p>)
                            }
                        </div>
                        <p className='w-full  text-[12px] font-bold text-gray-500 mt-3 flex items-center  gap-1 '>
                            {/* <span>در محله</span> */}
                            {item.area}
                        </p>
                        <div className='flex items-center justify-between'>
                            <p className='text-gray-500 text-[14px]'>
                                {
                                    dateStatus
                                    // new DateObject(item.adsDateTime.slice(0, 10)).convert(persian, persian_fa).format() == new DateObject().format() ? (item.adsDateTime.slice(0, 10)).convert(persian, persian_fa).format() : "دقایقی پیش"
                                    // new DateObject(item.adsDateTime.slice(0, 10)).convert(persian, persian_fa).format()
                                }
                            </p>
                            <div className='text-gray-500 text-[12px] flex items-center justify-between'>
                                <div className='flex flex-col justify-center items-center p-1 rounded'>
                                    <img src="/icons/new-like.svg" className='w-3.5 h-3.5' alt="" />
                                    <p>{item.likesCount == 0 ? "--" : item.likesCount.toLocaleString('fa')}</p>
                                </div>
                                <div className='flex flex-col justify-center items-center  p-1 rounded'>
                                    <img src="/icons/new-view.svg" className='w-3.5 h-3.5' alt="" />
                                    <p>{item.viewsCount == 0 ? "--" : item.viewsCount.toLocaleString('fa')}</p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className=' overflow-hidden rounded h-[150px] '>

                        {item.firstMasterImage !== "" ? (
                            CheckImage(item.firstMasterImage)
                        ) : (
                            CheckImage()
                        )}
                    </div>
                </>}
                {/* </div> */}
            </Link>
        </>
    )
}

export default TwoCard

